import { palette } from "../palette";


const MuiChip = {
  styleOverrides: {
    root: {
      borderRadius: '18px',
      padding: '0px 16px 0px 16px !important',
      fontSize: '1rem',
      fontWeight: '600',
      lineHeight: '21px',
      textTransform: 'capitalize',

      '&.deployed, &.draft, &.not_provisioned, &.not_scheduled, &.due, &.created, &.Low, &.uninstalled': {
        backgroundColor: palette.chipInfo.light,
        borderColor: palette.chipInfo.dark,
        color: palette.chipInfo.dark,
      },

      '&.approved, &.provisioned, &.completed, &.scheduled': {
        backgroundColor: palette.chipSuccess.light,
        borderColor: palette.success.dark,
        color: palette.success.dark,
      },

      '&.waiting_for_approval, &.provisioning, &.in_progress, &.not_completed, &.Medium, &.deploying, &.uninstalling': {
        backgroundColor: palette.chipWarning.light,
        borderColor: palette.chipWarning.dark,
        color: palette.chipWarning.dark,
      },

      '&.rejected, &.overdue, &.High, &.failed, &.uninstallation_failed, &.deployment_failed': {
        backgroundColor: palette.error.light,
        borderColor: palette.error.dark,
        color: palette.error.dark,
      },

      '&.on_hold': {
        backgroundColor: palette.chipOnHold.light,
        borderColor: palette.secondary.dark,
        color: palette.secondary.dark,
      },
    },
  },
};

export default MuiChip;
